/** Pixel Manager owns its WooCommerce browser funnel in PMW mode. */
export function pixelManagerOwnsWooMetaEvent(mode: boolean, eventName: string): boolean {
  return mode && ["PageView", "ViewContent", "AddToCart", "InitiateCheckout"].includes(eventName);
}
